import React, {
  ReactElement,
  useEffect,
  useState,
} from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import {
  IconButton,
  ListItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { debounce } from 'lodash';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';

export const CustomCellForPromotionActivity = ({
  item,
  onChange,
  deleteActivity,
}: {
  item: any;
  onChange: (id: number, values: any) => void;
  deleteActivity: (id: number) => void;
}): ReactElement => {
  const [open, setOpen] = React.useState<boolean>(false);
  const [values, setValues] = useState([
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
  ]);

  const debouncedOnChange = debounce(handleDebouncedOnChange, 500);

  function handleDebouncedOnChange(id: number, newValues: any) {
    onChange(id, newValues);
  }

  const handleClick = () => {
    setOpen(!open);
  };
  const handleDeleteActivity = (id: number) => {
    const confirm = window.confirm('Are you sure to delete?');
    if (confirm) {
      deleteActivity(id);
    }
  };
  const handlePaste = (event: any, index: number) => {
    event.preventDefault();
    const paste = event.clipboardData.getData('text');
    const pastedValues = paste.split('\t').slice(0, 50);
    const pastedValuesWithKey: any = {};
    pastedValues.map((item: any, pastedValueIndex: any) => {
      let pastedPrice = item.replace(' ', '');

      if (pastedPrice.includes(',') && pastedPrice.includes('.')) {
        pastedPrice = pastedPrice.replace(',', '');
      } else if (pastedPrice.includes(',')) {
        pastedPrice = pastedPrice.replace(',', '.');
      }
      pastedValuesWithKey[index + pastedValueIndex] = parseFloat(pastedPrice);
    });

    const defaultValues = [...values];
    const newValues = defaultValues.map((item: any, index) => {
      return pastedValuesWithKey[index]
        ? pastedValuesWithKey[index]
        : parseFloat(item);
    });

    setValues(newValues);
    onChange(item?.id, newValues);
  };

  useEffect(() => {
    if (item?.prices) {
      setValues(item?.prices);
    }
  }, [item]);

  return (
    <>
      <div className={'flex'}>
        <ListItemButton
          sx={{
            borderBottom: open ? '' : '1px solid #f3f3f3',
            background: open ? '#ebf4ff' : '',
            color: open ? '#438dbd' : '',
          }}
          onClick={() => handleClick()}
        >
          <ListItemText primary={item?.name} />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <IconButton
          color={'error'}
          onClick={() => {
            handleDeleteActivity(item?.id);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </div>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List
          sx={{
            background: open ? '#fbfdff' : '',
            borderBottom: open ? '' : '1px solid #ebf4ff',
          }}
          component="div"
          disablePadding
        >
          <ListItem
            sx={{
              padding: '0px',
            }}
          >
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    {values.map((value, index) => (
                      <TableCell
                        align={'center'}
                        sx={{
                          minWidth: '75px',
                          fontWeight: 'bold',
                        }}
                        key={index}
                      >
                        {index + 1}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    {values.map((value, index) => (
                      <TableCell
                        key={index}
                        sx={{
                          padding: '0px',
                          borderRight: '1px solid #e3e3e3',
                        }}
                      >
                        <NumericFormat
                          className={'w-full text-center'}
                          value={value}
                          thousandSeparator=" "
                          decimalScale={2}
                          fixedDecimalScale={true}
                          onValueChange={(valuesFromFormat) => {
                            const {
                              formattedValue,
                              value,
                              floatValue,
                            } = valuesFromFormat;
                            const newValues: any = [...values];
                            newValues[index] = floatValue;
                            setValues(newValues);
                            debouncedOnChange(item?.id, newValues);
                          }}
                          onPaste={(event: any) => handlePaste(event, index)}
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </ListItem>
        </List>
      </Collapse>
    </>
  );
};
